import reducer, * as reducers from './rootReducer';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';

export default {
  reducers,
  reducer,
  actions,
  actionTypes,
  selectors,
};
